/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{margin:0;padding:0;width:100%;height:100%;overflow:hidden;color:#3d3d3d}.wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex}app-aside[_ngcontent-%COMP%]{min-height:100%;display:block;width:74px;position:fixed;left:0;top:0}.content[_ngcontent-%COMP%]{flex:1}"];
export { styles as styles };
